import React, { useEffect, useState } from 'react';
import { Box, Button, Card, CardContent, CircularProgress, Grid, IconButton, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import TodayIcon from '@mui/icons-material/Today';
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import Groups2Icon from '@mui/icons-material/Groups2';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import axios from 'axios';
import { getCookie } from '../utils/cookies';
import { getopcinesMenu, verificarToken } from '../services/apis'
import QuickreplyIcon from '@mui/icons-material/Quickreply';
import { Fichar } from '../global/fichaje/Fichar';
import ConstructionIcon from '@mui/icons-material/Construction';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { TotemFichajeQr } from '../global/fichaje/TotemFichajeQr';
import { TotemFichajeNFC } from '../global/fichaje/TotemFichajeNFC';
import { FichajesPendientes } from '../global/fichaje/FichajesPendientes';
import { ResumenCalendarioHoy } from '../global/calendario/ResumenCalendarioHoy';
//mapa de iconos
let tamIco = 50;
const iconMapping = {
    TodayIcon: <TodayIcon sx={{ fontSize: tamIco }} />,
    FolderSpecialIcon: <FolderSpecialIcon sx={{ fontSize: tamIco }} />,
    Groups2Icon: <Groups2Icon sx={{ fontSize: tamIco }} />,
    AdminPanelSettingsIcon: <AdminPanelSettingsIcon sx={{ fontSize: tamIco }} />,
    QuickreplyIcon: <QuickreplyIcon sx={{ fontSize: tamIco }} />,
    Fichar: <Fichar />,
    ConstructionIcon: <ConstructionIcon sx={{ fontSize: tamIco }} />,
    AccessAlarmIcon: <AccessAlarmIcon sx={{ fontSize: tamIco }} />,
    ShoppingCartIcon: <ShoppingCartIcon sx={{ fontSize: tamIco }} />,
    FichajesPendientes: <FichajesPendientes />,

};

export const MainMenu = () => {
    // Global
    const navigate = useNavigate();

    // Estados auxiliares
    const [loaded, setLoaded] = useState(false);

    // Estados útiles
    const [opciones, setOpciones] = useState([]);
    const [rolUsuario, setRolUsuario] = useState(null);
    const [idUsuario, setIdUsuario] = useState(null);
    const [nombreUsuario, setNombreUsuario] = useState('');
    const rolesResumenCalendario = ['986', '985', '901'];

    // Cargar opciones menú principal
    const cargarOpciones = async () => {
        try {
            const token = await verificarToken();
            setRolUsuario(token?.rol ?? token?.usuario?.id_rol ?? token?.data?.usuario?.id_rol);
            setIdUsuario(token?.id ?? token?.usuario?.id ?? token?.data?.usuario?.id);
            setNombreUsuario(localStorage.getItem('DesRepresentante') || '');

            const response = await getopcinesMenu();
            setOpciones(response.data)
            setLoaded(true);
        } catch (error) {
            console.error("Error al cargar opciones del menu:", error);
            // localStorage.clear();
            // navigate("/login");
        }
    };

    const esEnlace = (texto) => {
        if (typeof texto !== 'string' || !texto.trim()) {
            return false;
        }

        // Patrones para detectar enlaces
        const patronesEnlace = [
            /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i, // http://, https://, ftp://
            /^www\.[^\s/$.?#].[^\s]*$/i,             // www.dominio.com
            /^[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,}(:[0-9]{1,5})?(\/.*)?$/i, // dominio.com
            /^[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,}(:[0-9]{1,5})?(\/.*)?\?[^\s]+$/i, // dominio.com?param=valor
            /^[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,}(:[0-9]{1,5})?(\/.*)?#[^\s]+$/i, // dominio.com#seccion
        ];

        return patronesEnlace.some(patron => patron.test(texto.trim()));
    };

    useEffect(() => {
        cargarOpciones();
    }, []);

    return (
        <>
            {loaded && rolesResumenCalendario.includes(String(rolUsuario)) && (
                <Box
                    sx={{
                        width: '100%',
                        boxSizing: 'border-box',
                        px: { xs: 2, md: 5 },
                        pt: { xs: 2, md: 3 },
                        pb: { xs: 1.5, md: 2 },
                        overflowX: 'hidden',
                    }}
                >
                    <Box sx={{ width: '100%', maxWidth: 1500, mx: 'auto' }}>
                        <ResumenCalendarioHoy idUsuarioActual={idUsuario} nombreUsuarioActual={nombreUsuario} />
                    </Box>
                </Box>
            )}

            <div className='menu-principal fade-in-2'>
                {!loaded && (<CircularProgress />)}
                {loaded && (
                    <Grid xs={12} container gap={3} justifyContent="center">
                        {opciones
                            .filter((opcion) => opcion.tipo === 4)
                            .map((opcion) => (
                                <Grid container xs={12} sm={6} md={4} lg={3} key={opcion.id}>
                                    {iconMapping[opcion.icon]}
                                </Grid>
                            ))}
                        {opciones
                            .filter((opcion) => opcion.tipo === 0)
                            .map((opcion) => (
                                <Grid container xs={12} sm={6} md={4} lg={3} key={opcion.id}>
                                    <Card
                                        onClick={() => { esEnlace(opcion.url) ? window.open(opcion.url, '_blank') : navigate(opcion.url) }}
                                        className="menu-card"
                                        style={{
                                            cursor: 'pointer',
                                            transition: '0.3s',
                                            borderRadius: 15,
                                            boxShadow: '0px 6px 10px rgba(0, 0, 0, 0.4)',
                                            background: "var(--fondoTarjeta)"
                                        }}
                                    >
                                        <CardContent style={{ textAlign: 'center', padding: '30px' }}>
                                            <Grid container direction={'column'} xs={12} alignItems={'center'} justifyContent={'space-between'}>
                                                <Grid
                                                    container
                                                    direction="row"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    xs={12}
                                                >
                                                    <IconButton size={'small'} color="primary">
                                                        {iconMapping[opcion.icon]}
                                                    </IconButton>
                                                    <Typography variant="h6" component="div">
                                                        {opcion.nombre.toUpperCase()}
                                                    </Typography>
                                                </Grid>

                                                <Typography variant="caption" sx={{ color: 'gray' }}>
                                                    {opcion.descripcion}
                                                </Typography>
                                            </Grid>

                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        {opciones
                            .filter((opcion) => opcion.tipo === 2)
                            .map((opcion) => (
                                <Grid container xs={12} sm={6} md={4} lg={3} key={opcion.id}>
                                    <TotemFichajeQr id={opcion.url}></TotemFichajeQr>
                                </Grid>
                            ))}
                        {opciones
                            .filter((opcion) => opcion.tipo === 3)
                            .map((opcion) => (
                                <Grid container xs={12} sm={6} md={4} lg={3} key={opcion.id}>
                                    <TotemFichajeNFC id={opcion.url}></TotemFichajeNFC>
                                </Grid>
                            ))}
                    </Grid>
                )}
            </div>

            {loaded && (
                <Box
                    sx={{
                        width: '100%',
                        boxSizing: 'border-box',
                        px: { xs: 2, md: 5 },
                        pb: 5,
                        overflowX: 'hidden',
                    }}
                >
                    <Box sx={{ width: '100%', maxWidth: 1500, mx: 'auto' }}>
                        <Box sx={{ mt: 3 }}>
                            {opciones
                                .filter((opcion) => opcion.tipo === 5)
                                .map((opcion) => (
                                    <Box key={opcion.id} sx={{ width: '100%' }}>
                                        {iconMapping[opcion.icon]}
                                    </Box>
                                ))}
                        </Box>
                    </Box>
                </Box>
            )}
        </>
    );
};
